import { ClearErrorAction, CLEAR_ERROR, ErrorType } from './error.action.type';

export const clearError = (errorType: ErrorType): ClearErrorAction => ({
  type: CLEAR_ERROR,
  payload: errorType,
});
